<template>
	<el-drawer title="添加资产" :visible.sync="visible" @close='close' size="820px" :close-on-click-modal="false" id="addShop">
		<div>
			<!-- 搜索 -->
			<div class="searchView">
				<el-input placeholder="请输入内容" v-model="keyword" clearable style="width: 200px;" @clear="search" @keyup.enter.native="search"></el-input>
				<el-button type="warning" @click="search" >搜索</el-button>
				<span style="padding-left:20px;">分类：</span>
				<el-select v-model="curType" filterable placeholder="请选择" style="width:250px;" @change="search">
					<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<!-- 商品列表 -->
			<div class="listBox" >
				<el-table :data="tableData" style="width: 100%" key="goods">
					<el-table-column prop="title" label="名称">
						<template slot-scope="scope">
							{{scope.row.name}}
						</template>
					</el-table-column>
					<el-table-column prop="title" label="分类">
						<template slot-scope="scope">
							{{scope.row.type&&scope.row.type.name}}
						</template>
					</el-table-column>
					<el-table-column label="规格" >
						<template slot-scope="scope">
							<el-button @click="select(scope.row)" type="warning" size="mini">+选择</el-button>
							{{scope.row.skuName}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<page :page="page.page" :total="page.total" @change="changePage" style="padding:10px;"></page>
	</el-drawer>
</template>
<script>
	import page from "@/components/page.vue"
	export default {
		components: {page},
		data() {
			return {
				visible: true,
				
				keyword:'',
				curType:'',
				typeList:[{id:'', name:'全部'},{id:'1', name:'办公'},{id:'2', name:'器械'},{id:'3', name:'用品'},{id:'4', name:'其它'}],
				
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData:[],
				
			};
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			close() {
				this.$emit("submit", {type:'close'});
			},
			// 选中
			select(row){  // 商品
				this.$emit("submit",{type:'success',data:row})
			},
			// 搜索
			search(){
				this.page.page = 1;
				this.getTableData()
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData()
			},
			//获取列表
			getTableData() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.keyword,
					"type": this.curType,
					"shopId": "",
					"isHaveStorage": false,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if (this.datetimerange && this.datetimerange.length == 2) {
				// 	params.starttime = ('' + new Date(this.datetimerange[0]).getTime()).substr(0, 10);
				// 	params.endtime = ('' + new Date(this.datetimerange[1]).getTime()).substr(0, 10);
				// }
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsInfo/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
		}
	};
</script>

<style scoped lang="scss">
	#addShop{
		::v-deep .el-drawer__header{
			margin-bottom:10px;
		}
		::v-deep .el-drawer__body{
			height: calc(100% - 55px);
			overflow-y: auto;
		}
	}
	
	.tabView:hover {
		cursor: pointer
	}

	.tabView {
		font-size: 16px;
		color: #2A2A2A;
		font-weight: bold;
		display: flex;
		width: 100%;
		border-bottom: solid 2px #F5F5F5;

		.tabTitle {
			width: 80px;
			margin-right: 50px;
			text-align: right;
			line-height: 40px;
		}

		.tabItem {
			margin-right: 40px;
			line-height: 40px;
			box-sizing: border-box;
		}

		.activeTab {
			margin-right: 40px;
			line-height: 40px;
			box-sizing: border-box;
			border-bottom: solid 2px $mainColor;
		}
	}

	.treeWarp:hover {
		cursor: pointer
	}

	.treeWarp {
		padding-top: 10px;
		font-size: 14px;
		color: #2A2A2A;
		overflow: hidden;

		.treeView {
			display: flex;
			margin-bottom: 10px;
			overflow: hidden;

			.treeLeft {
				width: 80px;
				margin-right: 44px;
				text-align: right;
				padding: 4px 0;
			}
			.treeActiveLeft{
				width: 80px;
				margin-right: 44px;
				text-align: right;
				padding: 4px 0;
				// background: $mainColor;
				// color: #fff;
				color:$mainColor;
			}

			.treeRight {
				flex: 1;
				overflow: hidden;

				.treeItem {
					margin-right: 20px;
					float: left;
					padding: 4px 6px;
				}

				.treeActiveItem {
					margin-right: 20px;
					float: left;
					padding: 4px 6px;
					// background: $mainColor;
					// color: #fff;
					color:$mainColor;
				}
			}

		}
	}

	.searchView {
		margin: 10px;
	}
	.listBox{
		::v-deep .column{
			display: flex;justify-content: space-around;flex-direction:column-reverse;
		}
	}
</style>
